// eslint-disable-next-line import/prefer-default-export
export {default as Section} from './Section';



// WEBPACK FOOTER //
// ./src/components/layouts/index.js